module.exports = __webpack_public_path__ + "static/media/IMG-20220422-WA0011.d3e1778e.jpg";